import React, { useEffect, useState } from 'react'
import { getRelativeBasePath } from '../../../../global/environments/path.js'
import { getUrlParameter } from '../../../../global/data/url.js'
import Loader from '../../../../components/Loading/Loading.jsx'
import { errorMessage } from '../common/institutionalConstants.js'
import {
  getUserInfo,
  getAccountReport,
  getUserInfoPreference,
  showAlertError,
  downloadFiles,
  accessStorage,
  showAlertSuccess,
  contactRM,
} from '../common/institutionalServiceHelper.js'
import YourReportsAccountSection from './YourReportsAccountSection.jsx'
import YourReportsAccordionSection from './YourReportsAccordionSection.jsx'

function InstitutionalYourReportsContainer() {
  const [isShowLoader, setShowLoader] = useState(false)
  const [userInfoData, setUserInfoData] = useState({})
  const [reportsData, setReportsData] = useState({})
  const [selected, setSelected] = useState({})

  useEffect(() => {
    getUserInfoData()
    showPopup()
  }, [])

  useEffect(() => {
    getReportsData()
  }, [selected])

  const updateSelected = (payload) => {
    setSelected((p) => ({ ...p, ...payload }))
  }

  const getUserInfoData = async () => {
    setShowLoader(true)
    try {
      const userData = accessStorage.getUserInfo()
      const responseData = await getUserInfo({
        userType: 'INST_CLT',
        userId: userData?.userId,
        actionCd: 'WEB',
      })

      if (responseData?.error) {
        setShowLoader(false)
        showErrorBanner()
        return
      }

      const {
        firstName,
        lastName,
        emailAddr,
        phoneNumbers,
        userId,
        rmDetails,
        userPreferances,
        instAcctInfoList,
      } = responseData?.value
      contactRM(rmDetails)
      accessStorage.setUserInfo({
        fullName: `${firstName} ${lastName}`,
        email: emailAddr,
        phone: phoneNumbers?.mobile,
      })
      const headerDropdownName = document?.getElementById('secondary-dropdown')
      headerDropdownName.innerText = `${firstName} ${lastName}`
      setUserInfoData({
        userId,
        rmDetails,
        userPreferances,
        instAcctInfoList,
      })
      if (instAcctInfoList?.length > 0) {
        updateSelected({ accountId: instAcctInfoList[0]?.acctId })
      }
    } catch (error) {
      showErrorBanner()
    }
    setShowLoader(false)
  }

  const updateUserPreferances = async (isExpand, rprtFreqType) => {
    getUserInfoPreference({
      expand: isExpand ? 'Y' : 'N',
      userId: userInfoData?.userId,
      rprtFreqType,
    })
  }

  const getReportsData = async () => {
    if (!userInfoData?.userId && !selected?.accountId) {
      return null
    }
    setShowLoader(true)
    try {
      const responseData = await getAccountReport({
        accountId: selected?.accountId,
        userId: userInfoData?.userId,
        actionName: 'WEB',
      })

      setReportsData({
        recentReports: responseData?.value?.recentReports,
        archiveReports: responseData?.value?.archiveReports,
      })
    } catch (error) {
      showErrorBanner()
    }
    setShowLoader(false)
  }

  const showErrorBanner = () => {
    showAlertError(errorMessage.yourReportText)
  }

  const downloadDocs = (payload) => {
    downloadFiles(
      payload,
      {
        userId: userInfoData?.userId,
        accountId: selected?.accountId,
        actionName: 'download',
      },
      setShowLoader
    )
  }

  const showPopup = () => {
    if (getUrlParameter('changePassword')) {
      showAlertSuccess({
        title: 'You have successfully changed your password.',
        text: 'Use your new password to log in.',
      })
    }
  }

  return (
    <div className="u-sizeConstrained u-marginTop10gu u-marginBottom4gu">
      {isShowLoader && <Loader />}
      <div className="Grid">
        <div className="u-sizeFull u-lg-size8of12 u-marginBottom6gu u-lg-marginBottom0 u-paddingRight5gu u-sm-paddingRight0">
          <YourReportsAccountSection
            accountList={userInfoData?.instAcctInfoList}
            onAccountChange={updateSelected}
            accountId={selected?.accountId}
          />
          <YourReportsAccordionSection
            updateUserPreferances={updateUserPreferances}
            reportsData={reportsData}
            downloadDocs={downloadDocs}
            userPreferances={userInfoData?.userPreferances}
          />
        </div>
        <div className="u-sizeFull u-lg-size4of12 u-marginBottom6gu u-lg-marginBottom0">
          <div className="u-bgColorSlateLight Content u-padding0">
            <h4 className="u-paddingVert2gu u-paddingHoriz8gu u-textColorWhite u-bgColorBrandLight u-margin0 u-textSizeMsrp1">
              Contact
            </h4>
            <div className="u-paddingVert4gu u-paddingHoriz8gu u-textSizeMsrm1">
              Your Relationship Manager: <br />
              {userInfoData?.rmDetails?.rmName} <br />
              {userInfoData?.rmDetails?.phoneNumber}
              <br />
              <a href={`${getRelativeBasePath()}/contact-us`}>
                {userInfoData?.rmDetails?.emailAddress}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="u-sizeFull  u-textSizeMsrm1">
        To view documents in PDF format, you need Adobe Reader software version
        6.0 or higher. <br />
        If you don’t have Adobe Acrobat Reader installed in your computer, you
        can
        <a href="https://get.adobe.com/reader/" target="_blank">
          {' '}
          download it now for free.
        </a>
      </div>
    </div>
  )
}

export default InstitutionalYourReportsContainer
